import React from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { CERRAR } from "./../../constants/icons/dashboard/filterIcons";
import SvgIcon from "@material-ui/core/SvgIcon";
import "./style.css";

const Tag = (props) => {
  return (
    <Button>
      <div style={{ marginLeft: 1, marginRight: 1 }}>
        <Typography
          style={{ color: "white", fontSize: 12, fontWeight: "bold" }}
        >
          {`${props.dato.value} `}
        </Typography>
      </div>

      <SvgIcon
        style={{ color: "white", fontSize: 15, marginLeft: 15 }}
        onClick={() => props.onClose(props.dato.name, props.dato.id)}
      >
        {CERRAR}
      </SvgIcon>
    </Button>
  );
};

export default Tag;
